import React from 'react';
import PropTypes from 'prop-types';
import Button  from '../../../common/components/button';

export const AlbumDeleteDialog = (props) => {
    return (
        <div>
            <p>Are you sure you want to delete this item?</p>
            <br/>
            <div className="btn-dialog-container">
                <Button buttonStyle="primary" className="btn-dialog" buttonLabel="Yes" onClick={()=>{props.deleteAlbum();props.parent.close();}} />
                <Button buttonStyle="secondary" className="btn-dialog" buttonLabel="No" onClick={()=>{props.parent.close();}} />
            </div>
        </div>
        
    );
};

AlbumDeleteDialog.propTypes = {
    deleteAlbum: PropTypes.func.isRequired,
    parent: PropTypes.shape({
        close: PropTypes.func
    })
};


// WEBPACK FOOTER //
// ./src/album-view/components/dialog/album-delete-dialog.jsx